import { withModalProvider } from "../../hoc/withModalProvider";
import { EditAdminNotificationButton as View, IProps } from "./EditAdminNotificationButton";

export const EditAdminNotificationButton = withModalProvider<IProps>(View);
